import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  getCustomers,
  getfeedback,
  deletefeedback,
  updatefeedback,
  createfeedback,
} from "../../../../Utility/Api";
import { Deletemodel } from "./../../../Common/Functions";
import { isReadonlyRoute, NaviGate, validateDateTime } from "../../../../Utility/function";
import { WarehouseContext } from "../../../../Utility/UserContext";
import CustomerAddModal from "../../../Common/CustomerAddModal";
import { useLocation } from "react-router-dom";


const ClientFeedbacks = () => {
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [feedbacks, setFeedbacks] = useState([]);
  const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
  const [user, setuser] = useState(UserItem)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editFeedback, setEditFeedback] = useState(null);
  const [showCustomer, setShowCustomer] = useState(false);
  const [newFeedback, setNewFeedback] = useState({
    customer_id: "",
    date: "",
    meeting_status: "Pending",
    meeting_type: "",
    start_date_time: "",
    end_date_time: "",
    title: "",
    description: "",
    created_by: user?.user_id
  });
  const [customers, setCustomers] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState(null);

  useEffect(() => {
    fetchFeedbacks();
    fetchSuppliers();
  }, []);

  const fetchSuppliers = async () => {
    try {
      const response = await getCustomers();
      if (response.data && response.data.data) {
        setCustomers(response.data.data);
      }
    } catch (error) {
      console.error("Error Fetching Customer data:", error);
    }
  };

  const fetchFeedbacks = async () => {
    try {
      const response = await getfeedback();
      if (response.data && response.data.data) {
        setFeedbacks(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching feedbacks:", error);
    }
  };

  const handleInputChange = (e) => {
    setNewFeedback({ ...newFeedback, [e.target.name]: e.target.value });
  };

  const handleCustomerChange = (e) => {
    setNewFeedback({ ...newFeedback, customer_id: e.target.value });
  };

  const handleClear = () => {
    setEditFeedback(false);
    setNewFeedback({
      customer_id: "",
      date: "",
      meeting_status: "Pending",
      meeting_type: "",
      start_date_time: "",
      end_date_time: "",
      title: "",
      description: "",
      created_by: user?.full_name
    });
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (newFeedback.start_date_time && newFeedback.end_date_time) {
        var error = validateDateTime(newFeedback.start_date_time, newFeedback.end_date_time, 'start date time', 'end date time');
        if (error) {
          toast.error(error);
          hideLoader();
          return;
        }
      }

      const feedbackData = {
        ...newFeedback,
        created_by: user?.full_name,
      };
      if (editFeedback) {
        await updatefeedback(editFeedback.id, feedbackData);
        toast.success("Feedback updated successfully");
      } else {
        await createfeedback(feedbackData);
        toast.success("Feedback added successfully");
      }
      fetchFeedbacks();
      setIsModalOpen(false);
      setEditFeedback(null);
      handleClear();
    } catch (error) {
      console.error("Error submitting feedback:", error);
    }
  };

  const confirmDelete = (id) => {
    setDeleteID(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      if (!deleteID) return;
      await deletefeedback(deleteID);
      setFeedbacks(feedbacks.filter((feedback) => feedback.id !== deleteID));
      toast.success("Feedback deleted successfully");
      setShowDeleteModal(false); // Close modal after delete
    } catch (error) {
      console.error("Error deleting feedback:", error);
    }
  };

  const handleEdit = (feedback) => {
    setEditFeedback(feedback);
    setNewFeedback(feedback);
    setIsModalOpen(true);
  };

  return (
    <div className="container mt-4">
      <NaviGate />
      <h6 className="mb-0 text-uppercase">Client Feedback</h6>
      <hr />
      {!readonly && (<button
        onClick={() => setIsModalOpen(true)}
        className="btn btn-primary mb-2"
      >
        Add Feedback
      </button>)}

      <table className="table table-striped table-bordered">
        <thead className="table">
          <tr>
            <th>S.No</th>
            <th>Title</th>
            <th>Date</th>
            <th>Customer ID</th>
            <th>Description</th>
            <th>created by</th>
            <th>Status</th>
            {!readonly && (<th>Actions</th>)}
          </tr>
        </thead>
        <tbody>
          {feedbacks.length > 0 ? (
            feedbacks.map((feedback, index) => (
              <tr key={feedback.id}>
                <td>{index + 1}</td>
                <td>{feedback.title}</td>
                <td>{feedback.date}</td>
                <td>{feedback.customer_name}</td>
                <td>{feedback.description}</td>
                <td>{feedback.created_by}</td>
                <td>
                  <span
                    className={`badge ${feedback.meeting_status === "Completed"
                      ? "bg-success"
                      : "bg-warning"
                      }`}
                  >
                    {feedback.meeting_status}
                  </span>
                </td>
                {!readonly && (<td>
                  <img
                    src="/assets/images/icons/delete.png"
                    onClick={() => confirmDelete(feedback.id)}
                    height={"16px"}
                  />
                  <img
                    src="/assets/images/icons/edit.png"
                    className="mx-2"
                    onClick={() => handleEdit(feedback)}
                    height={"16px"}
                  />
                  {feedback.meeting_url && (
                    <a
                      href={feedback.meeting_url}
                      className="btn btn-primary btn-sm"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Join
                    </a>
                  )}
                </td>)}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center text-muted">
                No feedbacks available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {isModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editFeedback ? "Edit Feedback" : "Add Feedback"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => handleClear()}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>

                  <div className="col-12 mb-3 position-relative">
                    <label className="form-label">Customer ID</label>
                    <div className="d-flex align-items-center">
                      {/* Select Dropdown */}
                      <select
                        className="form-control flex-grow-1 me-2" // Add margin to separate from button
                        name="customer_id"
                        value={newFeedback.customer_id}
                        onChange={(e) =>
                          setNewFeedback({
                            ...newFeedback,
                            customer_id: e.target.value,
                          })
                        }
                        required
                      >
                        <option value="">Choose a customer</option>
                        {customers.filter(item => item.status != 1).map((customer) => (
                          <option key={customer.id} value={customer.customer_id}>
                            {customer.name}
                          </option>
                        ))}
                      </select>

                      {/* Add Customer Button */}
                      <button
                        type="button"
                        className="btn btn-sm"
                        onClick={() => setShowCustomer(true)}
                        style={{ border: "none", background: "transparent" }}
                      >
                        <i className="bi bi-plus-circle fs-6 text-primary"></i>
                      </button>
                    </div>
                  </div>
                  <div className="row">

                    <div className="col-6 mb-3">
                      <label className="form-label">Title</label>
                      <input
                        type="text"
                        name="title"
                        className="form-control"
                        value={newFeedback.title}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    <div className="col-6 mb-3">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        name="date"
                        className="form-control"
                        value={newFeedback.date}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    <div className="col-6 mb-3">
                      <label className="form-label">Meeting Status</label>
                      <select
                        name="meeting_status"
                        className="form-control"
                        value={newFeedback.meeting_status}
                        onChange={handleInputChange}
                      >
                        <option value="Pending">Pending</option>
                        <option value="Completed">Completed</option>
                      </select>
                    </div>

                    <div className="col-6 mb-3">
                      <label className="form-label">Meeting Type</label>
                      <input
                        type="text"
                        name="meeting_type"
                        className="form-control"
                        value={newFeedback.meeting_type}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    <div className="col-6 mb-3">
                      <label className="form-label">Start Date & Time</label>
                      <input
                        type="datetime-local"
                        name="start_date_time"
                        className="form-control"
                        value={newFeedback.start_date_time}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    <div className="col-6 mb-3">
                      <label className="form-label">End Date & Time</label>
                      <input
                        type="datetime-local"
                        name="end_date_time"
                        className="form-control"
                        value={newFeedback.end_date_time}
                        onChange={handleInputChange}
                        required
                      />
                    </div>



                    <div className="col-12 mb-3">
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        className="form-control"
                        value={newFeedback.description}
                        onChange={handleInputChange}
                        required
                      ></textarea>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => handleClear()}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-success">
                      {editFeedback ? "Update" : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {showDeleteModal && (
        <Deletemodel
          setShowModal={setShowDeleteModal}
          handleDelete={handleDelete}
        />
      )}
      <CustomerAddModal
                showCustomer={showCustomer}
                setShowCustomer={setShowCustomer}
                onReqCustomer={fetchSuppliers} />
    </div>
  );
};

export default ClientFeedbacks;
